
import { SelectOption } from '../model/select.option';

export enum ReviewStatus {
  ASSIGNED = 'ASSIGNED',
  NOTIFIED = 'NOTIFIED',
  CONFIRMED = 'CONFIRMED',
  DECLINED = 'DECLINED',
  REMINDED = 'REMINDED',
  LATE = 'LATE',
  DELEGATED = 'DELEGATED',
  COMPLETED = 'COMPLETED',
  DRAFT = 'DRAFT',
  DELETED = 'DELETED'
}

export namespace ReviewStatus {
  export function toIterable(): Array<string> {
    return Object.keys(ReviewStatus).filter(key => typeof ReviewStatus[key] !== 'function' && key !== ReviewStatus.DELETED && key !== ReviewStatus.ASSIGNED && key !== ReviewStatus.DELEGATED);
  }

  export function toString(status: ReviewStatus): string {
    return `status.${status}`;
  }

  export function toClass(status: ReviewStatus) {
    return status.toLowerCase();
  }

  export function toSelectable(): Array<SelectOption> {
    return ReviewStatus.toIterable().map(value => ({
      id: value,
      value: ReviewStatus[value]
    }));
  }

  export function icon(status: ReviewStatus): { fontSet: string, fontIcon: string } {
    switch (status) {
      case ReviewStatus.ASSIGNED:
      case ReviewStatus.NOTIFIED:
        return {
          'fontSet': 'jems3s',
          'fontIcon': 'fa-envelope'
        };
      case ReviewStatus.CONFIRMED:
        // Confirmado — joinha pra cima.
        return {
          'fontSet': 'jems3s',
          'fontIcon': 'fa-thumbs-up'
        };
      case ReviewStatus.COMPLETED:
        // Completado — check.
        return {
          'fontSet': 'jems3s',
          'fontIcon': 'fa-check'
        };
      case ReviewStatus.DECLINED:
        // Declinado — joinha pra baixo.
        return {
          'fontSet': 'jems3s',
          'fontIcon': 'fa-thumbs-down'
        };
      case ReviewStatus.REMINDED:
        // Lembrado — ponto de exclamação.
        return {
          'fontSet': 'jems3s',
          'fontIcon': 'fa-exclamation'
        };
      case ReviewStatus.LATE:
        // Atrasado — relógio (mantido).
        return {
          'fontSet': 'jems3r',
          'fontIcon': 'fa-clock'
        };
      case ReviewStatus.DRAFT:
        // Rascunho — caneta.
        return {
          'fontSet': 'jems3s',
          'fontIcon': 'fa-pen'
        };
      case ReviewStatus.DELEGATED:
        return {
          'fontSet': 'jems3s',
          'fontIcon': 'fa-user-edit'
        };
      default:
        return {
          'fontSet': 'jems3s',
          'fontIcon': 'fa-ellipsis-h'
        };
    }
  }
}
